import classNames from 'classnames';

function Image({src, alt, staticImage, dynamicImage, className, fluid, thumbnail}) {
  const compClass = classNames({
    [className]: className,
    [`img-fluid`]: fluid,
    [`img-thumbnail`]: thumbnail
  });

  return (
    <>
      {staticImage && <img src={process.env.PUBLIC_URL + src} alt={alt || ''} className={compClass} />}
      {dynamicImage && <img src={process.env.REACT_APP_BASE_URL + src} alt={alt || ''} className={compClass} />}
    </>
  )
}

export default Image